module.exports = __webpack_public_path__ + "static/img/publication.f83a14e5.jpg";